/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, Alert, InputGroup,
  NavItem, NavLink, Nav, TabPane, TabContent,
} from 'reactstrap';

import Papa from 'papaparse';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { post } from '../../helpers/api_helper';
import SupplierPicker from './SupplierPicker';
import TrucksFieldset from './OrderTrucksFieldset';
import OrderItemsFieldset from './OrderItemsFieldset';

function OrderForm(props) {
  const { actionUrl, entity, t } = props;
  const [, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [uploading, setUploading] = useState(false);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    extendedTimeOut: 20000, // Additional time when the user hovers over the toast
  };

  // Function to handle file upload
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const input = event.target;

    if (file) {
      if (!entity.id) {
        toastr.error(t('Save the sourcing order before uploading a manifest'));
        input.value = '';
        return;
      }

      setUploading(true);
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          try {
            const response = await post(`/api/sourcing/orders/upload-manifest/${entity.id}`, {
              rows: results.data,
            });

            if (response.errors.length > 0) {
              toastr.warning(
                t(`Processed ${response.inducted_rows} row(s), with ${response.errors.length} error(s).`),
                t('Manifest processed with warnings'),
              );
            } else {
              toastr.success(
                t(`Processed ${response.inducted_rows} row(s) and printed ${response.inducted_qty} label(s).`),
                t('Manifest processed'),
              );
            }
          } catch (error) {
            toastr.error(error.message, t('Error processing manifest'));
          } finally {
            setUploading(false);
            input.value = '';
          }
        },
        error: (error) => {
          setUploading(false);
          input.value = '';
          toastr.error(error.message, t('Error parsing manifest'));
        },
      });
    }
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(actionUrl, values);
      setErrorMessage(null);

      toastr.success(t(`Item ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    reference: Yup
      .string()
      .required(props.t(t('Reference is required'))),
    supplier_id: Yup.number().required(t('Supplier is required')),
    supplier_program: Yup.string()
      .required(t('Program is required')),
    cost: Yup.string().matches(/^[0-9]+\.[0-9]{2}$/, { message: t('Must be in price format') }),
    shipments: Yup.array().of(
      Yup.object().shape({
        reference: Yup
          .string()
          .required(props.t(t('Reference is required'))),
        cost: Yup.string().matches(/^[0-9]+\.[0-9]{2}$/, { message: t('Must be in price format') }).nullable(),
        origin: Yup.string().nullable(),
      }),
    ),
    items: Yup.array().of(
      Yup.object().shape({
        supplier_item: Yup.object().shape({
          id: Yup.number(),
          supplier_sku: Yup.string(),
          supplier_id: Yup.number(),
        }),
        supplier_items_id: Yup.number(),
        qty: Yup.number(),
        price: Yup.number(),
      }),
    ),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values,
        }) => (
          <Form className="mt-3" id="OrderEditForm" autoComplete="off">
            <Row>
              <Col md="3">
                <Nav pills className="flex-column">
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '1',
                      })}
                      onClick={() => {
                        setActiveTab('1');
                      }}
                    >
                      {props.t('General')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '2',
                      })}
                      onClick={() => {
                        setActiveTab('2');
                      }}
                    >
                      {props.t('Manifest')}
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col md="9">
                <TabContent
                  activeTab={activeTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <h5>{props.t('Order')}</h5>

                    <Field name="id" type="hidden" />
                    <div className="row mt-4 mb-4">
                      <Label
                        for="reference"
                        className="col-md-3 col-form-label"
                      >
                        {props.t('Reference')}
                      </Label>
                      <Col md={3}>
                        <Field
                          type="text"
                          className={`form-control ${(errors.reference && touched.reference ? 'is-invalid' : '')}`}
                          id="reference"
                          name="reference"
                        />
                        <ErrorMessage
                          name="reference"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </div>

                    <div className="row mt-4 mb-4">
                      <Label
                        for="cost"
                        className="col-md-3 col-form-label"
                      >
                        {props.t('Cost')}
                      </Label>
                      <Col md={3}>
                        <Field
                          type="text"
                          className={`form-control ${(errors.cost && touched.cost ? 'is-invalid' : '')}`}
                          id="cost"
                          name="cost"
                        />
                        <ErrorMessage
                          name="cost"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </div>

                    <div className="row mt-4 mb-4">
                      <Label
                        for="notes"
                        className="col-md-3 col-form-label"
                      >
                        {props.t('Notes')}
                      </Label>
                      <Col md={6}>
                        <Field
                          as="textarea"
                          className={`form-control ${(errors.notes && touched.notes ? 'is-invalid' : '')}`}
                          id="notes"
                          name="notes"
                          rows={4}
                        />
                        <ErrorMessage
                          name="notes"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </div>

                    <SupplierPicker />

                    <hr />

                    <h5>{t('Receiving')}</h5>

                    <FieldArray name="shipments" className="mt-3">
                      {(arrayHelpers) => (
                        <div className="mt-3">
                          <TrucksFieldset arrayHelpers={arrayHelpers} />
                        </div>
                      )}
                    </FieldArray>
                  </TabPane>
                </TabContent>
                <TabContent
                  activeTab={activeTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="2">
                    <h5>{props.t('Items Manifest')}</h5>

                    <FieldArray name="items" className="mt-3">
                      {(arrayHelpers) => (
                        <>
                          <div className="hstack gap-3">
                            <Button
                              className="btn btn-info btn-sm"
                              style={{ width: '100px' }}
                              onClick={() => {
                                if (values.supplier_id) {
                                  arrayHelpers.push({
                                    qty: '1',
                                    price: '0',
                                    supplier_item: {
                                      supplier_sku: '',
                                      notes: '',
                                      suppliers_id: values.supplier_id,
                                    },
                                  });
                                } else {
                                  toastr.error(t('Select a supplier first'));
                                }
                              }}
                            >
                              <span className="bx bx-plus" />
                              {props.t('Add Item')}
                            </Button>

                            <div>
                              <InputGroup size="sm" style={{ width: '300px' }}>
                                <input type="file" accept=".csv" onChange={handleFileUpload} className="form-control" />
                                <Button color={uploading ? 'warning' : 'info'} size="sm" className={uploading ? 'btn-soft-warning' : 'btn-soft-info'} type="button" onClick={() => false}>
                                  <span className={`mdi ${uploading ? 'mdi-loading mdi-spin' : 'mdi-folder-upload'}`} />
                                  {' '}
                                  {uploading ? props.t('Processing...') : props.t('Upload CSV')}
                                </Button>
                              </InputGroup>
                              <small className="text-muted ps-1">
                                {props.t('CSV must contain columns:')}
                                {' '}
                                <small className="text-dark">Part Number, Qty</small>
                              </small>
                              <br />
                              <small className="text-muted ps-1">
                                {props.t('Or the columns:')}
                                {' '}
                                <small className="text-dark">Supplier Sku, Qty</small>
                              </small>
                              <br />
                              <small className="text-muted ps-1">
                                {props.t('Supplier sku uses the supplier catalog when available; part number resolves directly to our item catalog.')}
                              </small>
                              {!entity.id && (
                                <>
                                  <br />
                                  <small className="text-muted ps-1">
                                    <small className="text-dark">{props.t('Save the order first to process a manifest.')}</small>
                                  </small>
                                </>
                              )}
                              <br />
                              <small className="text-muted ps-1">
                                {props.t('Manual rows below remain available, but CSV upload now creates inductions and prints labels.')}
                              </small>
                            </div>
                          </div>
                          <OrderItemsFieldset arrayHelpers={arrayHelpers} />
                        </>
                      )}
                    </FieldArray>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

OrderForm.defaultProps = {
  entity: {
    reference: '',
    notes: '',
    shipments: [],
  },
  onSuccess: () => {},
};

OrderForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(OrderForm));
